import React from 'react'
import Banner from '../components/Banner/Banner';
import CoinsTable from '../components/CoinsTable';

const HomePage = () => {
  return (
      <>
        <Banner />
        <CoinsTable />
      </>
  )
}

export default HomePage;